<template>

  <div class="flex-column">
    <el-dialog top="2vh" v-if="replaceBadWord.show"
               :title="'Tin nhắn gửi đi có chứa ' + replaceBadWord.items.length + ' từ khóa nhạy cảm'" width="500px"
               :visible.sync="replaceBadWord.show" :close-on-click-modal="false" :destroy-on-close="true">

      <div>
        <div>
          <div class="d-flex fw-bolder font-size-14 mb-3">
            <div class="w-150px">Từ cấm</div>
            <div class="flex-1">Từ thay thế</div>
            <div style="width: 60px"></div>
          </div>
          <div class="divider-custom"></div>
          <div style="max-height: 200px;overflow-y: auto;">
            <div v-for="(item, index) in replaceBadWord.items" :key="index">
              <div class="d-flex font-size-14 my-2">
                <div class="w-150px">
                  <div class="d-flex">
                    <div class="">{{ item.key }}</div>
                  </div>
                </div>
                <div class="flex-1">
                  <el-input placeholder="Nội dung thay thế" @input="handleInputReplace(item)"
                            v-model="item.replace"></el-input>
                </div>

              </div>
              <div class="divider-custom"></div>
            </div>
          </div>
        </div>
        <div class="my-2 ">Nội dung sau chỉnh sửa px-1 py-2</div>
        <el-input ref="inputText" resize="none" type="textarea" :autosize="{ minRows: 4, maxRows: 5 }"
                  v-model="replaceBadWord.content" disabled />
        <div class="d-flex justify-content-end mt-2">
          <el-button size="sm" plain type="danger" @click="closeReplaceBadWord()">Hủy</el-button>
          <el-button size="sm" type="primary" @click="sendReplace()">Gửi tin nhắn</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog v-if="showTagHistoryPopup" top="40px" :visible.sync="showTagHistoryPopup" title="Lịch sử gắn tag"
               append-to-body width="800px" destroy-on-close>
      <TagHistoryPopup :conversation-id="selectCon.id" />
    </el-dialog>
    <el-dialog :title="getTitle()" :visible.sync="showPopupMessage" :close-on-click-modal="false" width="500px"
               destroy-on-close>
      <div>
        <el-input class="text-break" type="textarea" placeholder="Nhập nội dung tin nhắn" :row="2"
                  v-model="messageText"></el-input>
        <div class="d-flex justify-content-end">
          <el-button type="primary" size="md" class="mt-2" @click="sendMessage()">Gửi</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog width="360px" v-if="showInfoPopup" :visible.sync="showInfoPopup" :close-on-click-modal="false"
               destroy-on-close>
      <ProfileInfoPopup :conversation="selectCon" />
    </el-dialog>
    <el-dialog :title="'Đặt biệt danh cho: ' + selectCon.toName" width="500px" v-if="showPopOverSwName"
               :visible.sync="showPopOverSwName" destroy-on-close>
      <div>
        <el-input placeholder="Nhập biệt danh" type="textarea" :rows="3" v-model="selectCon.swName"
                  resize="none"></el-input>
        <div class="d-flex justify-content-end mt-2">
          <el-button type="primary" size="mini" plain @click="saveSwName()">Lưu</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="contact-detail-header px-1 py-2" style="background-color: #FAFAFA;">
      <div class="d-flex justify-content-between align-items-center">
        <!-- Vòng lặp v-for bên trái -->
        <div class="d-flex" style="margin-left: 12px;">
          <div v-for="type in types" :key="type.val" class="me-1">
            <el-button class="menuType" @click="selectType = type.val; getContact(true)"
                       v-bind:style="getMenuStyle(type)" style="border: none; background-color: #FAFAFA;" :plain="true">
              <span>{{ type.name }} ({{ numberOfType(type.val) }})</span>
            </el-button>
          </div>
        </div>

        <!-- Phần tử căn phải -->
        <div class="d-flex align-items-center">
          <el-input prefix-icon="el-icon-search" @input="searchKeyChanged" placeholder="Tìm kiếm..." class="mx-2"
                    style="width: 160px;"
                    v-model="searchKey"></el-input>

          <el-select v-model="selectedTag" @change="getContact" filterable default-first-option
                     class=" mx-2" style="width: 160px">
            <el-option :value="0" label="Tất cả thẻ đã gắn" :key="0">
              <div class="d-flex">
                <div v-bind:style="'background-color :#1f69c7'" style="height: 20px;width: 20px;" />
                <div style="line-height: 20px;margin:0px 4px">Tất cả thẻ đã gắn</div>
              </div>
            </el-option>
            <el-option v-for="item in app.tags" :key="item.id" :label="item.name"
                       :value="item.id">
              <div class="d-flex">
                <div v-bind:style="'background-color :' + item.color" style="height: 20px;width: 20px;" />
                <div style="line-height: 20px;margin:0px 4px">{{ item.name }}</div>
              </div>
            </el-option>
          </el-select>
        </div>
      </div>
    </div>

    <div class="divider-custom" />
    <div v-loading="loading" class="contact-item-list flex-1">
      <div v-for="(item) in itemList" :key="item.id">
        <div v-if="item.zaloConversation.group" class="bg-white">
          <div @click="openChatConversation($event, item.zaloConversation)" class="contact-item py-2 px-3">
            <div @click.stop="showInfo(item.zaloConversation)" style="padding-top: 5px;">
              <el-avatar class="pointer" :size="52" :src="getAvatar(item.zaloConversation)"></el-avatar>
            </div>
            <div class="flex-1 mx-3">
              <div class="d-flex">
                <div class="fw-semibold font-size-16 text-1-line pointer" @click.stop="showInfo(item.zaloConversation)">
                  <!-- {{ (item.zaloConversation.group ? "Nhóm: " : (item.zaloConversation.page ? "Zalo OA: " : "")) + -->
                  {{ item.zaloConversation.toName }}
                </div>


                <el-tooltip class="item pointer" effect="dark" content="Đặt biệt danh cho liên hệ" slot="reference"
                            placement="top">
                  <i class="el-icon-edit-outline font-size-16 fw-bolder mt-1 mx-2" style="color: #D5D7DD"
                     @click.stop="showPopOver(item.zaloConversation)" />
                </el-tooltip>


                <el-popover placement="top" trigger="click">
                  <div class="w-300px flex-column">
                    <div class="fw-semibold font-size-15">Gắn tag</div>
                    <div class="d-flex mt-2 flex-wrap">
                      <div v-for="tag in app.tags" :key="tag.id">
                        <div @click.stop="addOrRemoveTag(tag, item.zaloConversation)">
                          <Tag :item="tag" :selected="checkSelectedTag(item.zaloConversation.tags, tag.id)"
                               :isButton="true" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <el-tooltip class="item pointer" effect="dark" content="Gắn tag" slot="reference" placement="top">
                    <el-tag size="mini" @click.stop
                            v-bind:style="{ 'border-radius': '4px', border: '0px solid', color: '#D5D7DD', 'background-color': '#fff', 'border-color': '#0A58C0', }"
                            effect="dark" class="pointer">
                      <i class="icon-tag-2 font-size-16" />
                    </el-tag>
                  </el-tooltip>

                </el-popover>

                <div v-if="item.zaloConversation.phone && (isAdminUser() || app.showPhoneInContact)" class="d-flex">
                  <div class="mx-2" style="color: gray;">|</div>
                  <div class="text-info">{{ item.zaloConversation.phone }}</div>
                  <div class="pointer mx-1">
                    <el-tooltip content="Sao chép số diện thoại" placement="left">
                      <img src="/assets/icon/icon_union.svg" size="16"
                           @click.stop="copyToClipboard(item.zaloConversation.phone, 'Đã sao chép số điện thoại')" />
                    </el-tooltip>
                  </div>
                </div>

                <div v-if="item.zaloConversation.group && parsedJSON(item.zaloProfile.data).data" class="d-flex">
                  <div class="mx-2" style="color: gray;">|</div>
                  <div class="num-member-info" style="color: #696B72; font-weight: 400">
                    {{ getTotalMembers(item.zaloProfile.data, item.zaloConversation.toId).toString() }} thành viên
                    <span>(Đồng bộ lần cuối: {{ item.zaloProfile.updateAt ? formatDateTimeShort(item.zaloProfile.updateAt) : item.zaloProfile.updateAt }})</span>
                  </div>

                </div>

              </div>
              <div class="font-size-14 text-danger"
                   v-if="item.zaloConversation.swName && item.zaloConversation.swName.length > 0">Biệt danh :
                {{ item.zaloConversation.swName }}
              </div>
              <!-- <div v-if="item.phone && (isAdminUser()|| app.showPhoneInContact)" class="d-flex">
                  <div class="text-info">{{ item.phone }}</div>
                  <div class="pointer mx-1">
                    <el-tooltip content="Sao chép số diện thoại" placement="left">
                      <img src="/assets/icon/icon_union.svg" size="16"
                           @click="copyToClipboard(item.phone, 'Đã sao chép số điện thoại')" />
                    </el-tooltip>
                  </div>
                </div> -->
              <div v-if="item.zaloConversation.tags.length > 0" class="d-flex">
                <div v-for="tag in item.zaloConversation.tags" :key="tag.id">
                  <div
                    class="d-flex pointer">
                    <div>
                      <TagV2
                        v-if="checkTag(tag.id)"
                        :data="tag"
                        :inactive="false" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div :id="`menuButton-${item.zaloConversation.id}`" class="justify-content-end"
                 style="padding: 20px 20px 20px 20px" @click.stop="showMenuConversationV2($event, item)">
              <el-tooltip class="item pointer" effect="dark"
                          :content="item.zaloConversation.group === true ? 'Tác vụ nhóm' : 'Tác vụ cá nhân'"
                          placement="top">
                <IconV2 name="el-icon-more"></IconV2>
              </el-tooltip>
            </div>

            <!-- <div v-if="!item.hidden">
                <el-tooltip class="item pointer mx-1" effect="dark"
                            :content="contentNotify(item.pushNotify)+ ' thông báo khi có tin nhắn mới'"
                            placement="top">
                  <i v-bind:class="item.pushNotify?'icon-bell':'icon-unbell'" class="font-size-20 text-secondary "
                     @click="pushNotifyChange(item)" />
                </el-tooltip>
              </div> -->

            <!-- <div class="mx-2 " style="border-left:2px solid #DCDFE9;height: 20px" v-if="!item.zaloConversation.hidden" />
              <el-tooltip class="item pointer" effect="dark" content="Lịch sử gắn tag" slot="reference"
                          placement="top">
                <i class="icon-tag-2 font-size-20" @click="showTagHistory(item.zaloConversation)" />
              </el-tooltip>
              <div class="mx-2 " style="border-left:2px solid #DCDFE9;height: 20px" />
              <div v-if="isAdminUser()">
                <el-tooltip class="item pointer mx-1" effect="dark"
                            :content="contentHidden(item.zaloConversation.hidden) +' trò chuyện'"
                            placement="top">
                  <i v-bind:class="item.zaloConversation.hidden?'icon-hidden':'icon-visible'" class="font-size-20 text-secondary"
                     @click="hiddenChange(item)" />
                </el-tooltip>
              </div>
              <div class="mx-2 " style="border-left:2px solid #DCDFE9;height: 20px"
                   v-if="!item.zaloConversation.hidden && isAdminUser()" />
              <el-tooltip class="item pointer mx-1" effect="dark" content="Nhắn tin" v-if="!item.zaloConversation.hidden"
                          placement="top">
                <div @click="showPopup(item.zaloConversation)">
                  <i class="icon-mess font-size-20 text-secondary" />
                </div>
              </el-tooltip>
              <div class="mx-2 " style="border-left:2px solid #DCDFE9;height: 20px" v-if="!item.zaloConversation.page && !item.zaloConversation.group" />
              <el-tooltip class="item pointer mx-1" effect="dark" content="Thông tin" v-if="!item.zaloConversation.page && !item.zaloConversation.group"
                          placement="top">
                <div @click="showInfo(item.zaloConversation)">
                  <i class="el-icon-user font-size-20 text-secondary fw-bold"></i>
                </div>
              </el-tooltip> -->
            <div class="mx-1" />
          </div>
          <div class="divider-custom" />
        </div>
      </div>
      <div v-for="(letter, itemIndex) in sortedGroups" :key="itemIndex">
        <div class="d-flex py-2 px-3 justify-content-between" style="font-weight: bold;
                                        font-size: 18px;
                                        padding: 10px 0;
                                        color: #333;
                                        background-color: #FAFAFA;
                                        border-bottom: 1px solid #EAECF2;">
          {{ letter }}
          <div class="justify-content-end" style="font-weight: lighter; color: #BABCC4;">
            {{ groupedItems[letter].length.toString().padStart(2, "0") }}
          </div>
        </div>
        <div v-for="(item, itemIndex1) in groupedItems[letter]" :key="itemIndex1" class="bg-white">
          <div @click="openChatConversation($event, item.zaloConversation)" class="contact-item py-2 px-3">
            <div @click.stop="showInfo(item.zaloConversation)">
              <el-avatar class="pointer" :size="52" :src="getAvatar(item.zaloConversation)"></el-avatar>
            </div>
            <div class="flex-1 mx-3">
              <div class="d-flex">
                <div class="fw-semibold font-size-16 text-1-line pointer" @click.stop="showInfo(item.zaloConversation)">
                  {{ (item.zaloConversation.group ? "Nhóm: " : (item.zaloConversation.page ? "Zalo OA: " : "")) +
                (item.zaloConversation.toName || '') }}
                </div>


                <el-tooltip class="item pointer" effect="dark" content="Đặt biệt danh cho liên hệ" slot="reference"
                            placement="top">
                  <i class="el-icon-edit-outline font-size-16 fw-bolder mt-1 mx-2" style="color: #D5D7DD"
                     @click.stop="showPopOver(item.zaloConversation)" />
                </el-tooltip>


                <el-popover placement="top" trigger="click">
                  <div class="w-300px flex-column">
                    <div class="fw-semibold font-size-15">Gắn tag</div>
                    <div class="d-flex mt-2 flex-wrap">
                      <div v-for="tag in app.tags" :key="tag.id">
                        <div @click.stop="addOrRemoveTag(tag, item.zaloConversation)">
                          <Tag :item="tag" :selected="checkSelectedTag(item.zaloConversation.tags, tag.id)"
                               :isButton="true" />
                        </div>
                      </div>
                    </div>
                  </div>


                  <el-tooltip class="item pointer" effect="dark" content="Gắn tag" slot="reference" placement="top">
                    <el-tag size="mini" @click.stop
                            v-bind:style="{ 'border-radius': '4px', border: '0px solid', color: '#D5D7DD', 'background-color': '#fff', 'border-color': '#0A58C0', }"
                            effect="dark" class="pointer">
                      <i class="icon-tag-2 font-size-16" />
                    </el-tag>
                  </el-tooltip>

                </el-popover>

                <div v-if="item.zaloConversation.phone && (isAdminUser() || app.showPhoneInContact)" class="d-flex">
                  <div class="mx-2" style="color: gray;">|</div>
                  <div class="text-info">{{ item.zaloConversation.phone }}</div>
                  <div class="pointer mx-1">
                    <el-tooltip content="Sao chép số diện thoại" placement="left">
                      <img src="/assets/icon/icon_union.svg" size="16"
                           @click.stop="copyToClipboard(item.zaloConversation.phone, 'Đã sao chép số điện thoại')" />
                    </el-tooltip>

                  </div>
                </div>
                <div v-if="parsedJSON(item.zaloProfile.data).data" class="d-flex">
                  <div class="mx-2" style="color: gray;">|</div>
                  <div>Tên tài khoản: {{ getZaloName(item.zaloProfile.data, item.zaloConversation.toId) }}</div>
                </div>
              </div>
              <div class="font-size-14 text-danger"
                   v-if="item.zaloConversation.swName && item.zaloConversation.swName.length > 0">Biệt danh :
                {{ item.zaloConversation.swName }}

              </div>
              <!-- <div v-if="item.phone && (isAdminUser()|| app.showPhoneInContact)" class="d-flex">
                  <div class="text-info">{{ item.phone }}</div>
                  <div class="pointer mx-1">
                    <el-tooltip content="Sao chép số diện thoại" placement="left">
                      <img src="/assets/icon/icon_union.svg" size="16"
                           @click="copyToClipboard(item.phone, 'Đã sao chép số điện thoại')" />
                    </el-tooltip>
                  </div>
                </div> -->
              <div v-if="item.zaloConversation.tags.length > 0" class="d-flex">
                <div v-for="tag in item.zaloConversation.tags" :key="tag.id">
                  <div
                    class="d-flex pointer">
                    <div style="margin: 2px">
                      <TagV2
                        v-if="checkTag(tag.id)"
                        :data="tag"
                        :inactive="false" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div :id="`menuButton-${item.zaloConversation.id}`" class="justify-content-end"
                 style="padding: 20px 20px 20px 20px" @click.stop="showMenuConversationV2($event, item)">
              <el-tooltip class="item pointer" effect="dark"
                          :content="item.zaloConversation.group === true ? 'Tác vụ nhóm' : 'Tác vụ cá nhân'"
                          placement="top">
                <IconV2 name="el-icon-more"></IconV2>
              </el-tooltip>
            </div>


            <!-- <div v-if="!item.hidden">

                <el-tooltip class="item pointer mx-1" effect="dark"
                            :content="contentNotify(item.pushNotify)+ ' thông báo khi có tin nhắn mới'"
                            placement="top">
                  <i v-bind:class="item.pushNotify?'icon-bell':'icon-unbell'" class="font-size-20 text-secondary "
                     @click="pushNotifyChange(item)" />
                </el-tooltip>

              </div> -->
            <!-- <div class="mx-2 " style="border-left:2px solid #DCDFE9;height: 20px" v-if="!item.zaloConversation.hidden" />
              <el-tooltip class="item pointer" effect="dark" content="Lịch sử gắn tag" slot="reference"
                          placement="top">
                <i class="icon-tag-2 font-size-20" @click="showTagHistory(item.zaloConversation)" />
              </el-tooltip>
              <div class="mx-2 " style="border-left:2px solid #DCDFE9;height: 20px" />
              <div v-if="isAdminUser()">
                <el-tooltip class="item pointer mx-1" effect="dark"
                            :content="contentHidden(item.zaloConversation.hidden) +' trò chuyện'"
                            placement="top">
                  <i v-bind:class="item.zaloConversation.hidden?'icon-hidden':'icon-visible'" class="font-size-20 text-secondary"
                     @click="hiddenChange(item.zaloConversation)" />
                </el-tooltip>
              </div>
              <div class="mx-2 " style="border-left:2px solid #DCDFE9;height: 20px"
                   v-if="!item.hidden && isAdminUser()" />
              <el-tooltip class="item pointer mx-1" effect="dark" content="Nhắn tin" v-if="!item.zaloConversation.hidden"
                          placement="top">
                <div @click="showPopup(item.zaloConversation)">
                  <i class="icon-mess font-size-20 text-secondary" />
                </div>
              </el-tooltip>
              <div class="mx-2 " style="border-left:2px solid #DCDFE9;height: 20px" v-if="!item.zaloConversation.page && !item.zaloConversation.group" />
              <el-tooltip class="item pointer mx-1" effect="dark" content="Thông tin" v-if="!item.zaloConversation.page && !item.zaloConversation.group"
                          placement="top">
                <div @click="showInfo(item.zaloConversation)">
                  <i class="el-icon-user font-size-20 text-secondary fw-bold"></i>
                </div>
              </el-tooltip> -->
            <div class="mx-1" />
          </div>
          <div class="divider-custom" />
        </div>
      </div>
    </div>

    <MenuConversationV2 ref="MenuConversationV2" v-show="isMenuVisible" :conversation="conversation" :profile="profile"
                        :members="members" @addGroup="addGroup" @addMembers="addMembers" @getGroupInfo="getGroupInfo"
                        @is-changed="handleGetContact" @is-block="handleGetProfile" />

    <div class="d-flex justify-content-center mt-4">
      <el-pagination v-if="pageInfo.total > 1" background layout="prev, pager, next" :current-page="pageInfo.page"
                     :total="pageInfo.total" :page-size="pageInfo.pageSize" @current-change="currentSwPageChanged"
                     @prev-click="pageInfo.page -= 1" @next-click="pageInfo.page += 1"></el-pagination>

    </div>

    <!-- <ConversationV2
      ref="messageV2"
      :searchKeyMessage="this.filterMessage?.searchKey || ''"
      :conversation="conversation"
      @onSelect="onSelectConversation" /> -->
  </div>
</template>

<script>
import Tag from "@/components/common/TagCustom";
import StringUtil from "../../lib/StringUtil";
import ProfileInfoPopup from "../ProfileInfoPopup";
import TagHistoryPopup from "../tag/TagHistoryPopup";
import MenuConversationV2 from "../ContactList/MenuConversationV2.vue";
import TagV2 from "../TagV2.vue";

export default {
  name: "ContactListConversation",
  props: ["selectedAccount"],
  components: { TagHistoryPopup, ProfileInfoPopup, Tag, MenuConversationV2, TagV2 },
  watch: {
    selectedAccount: function() {
      this.getContact();
    }
  },
  data() {
    return {
      loading: false,
      searchKey: "",
      selectedTags: [],
      pageInfo: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      itemList: [],
      selectedTag: 0,
      showPopupMessage: false,
      selectCon: {},
      messageText: "",
      types: [
        { name: "Tất cả", val: "all" },
        { name: "Cá nhân", val: "personal" },
        { name: "Nhóm", val: "group" },
        { name: "Liên hệ ẩn", val: "hidden" },
        { name: "Zalo OA", val: "page" }
      ],
      selectType: "all",
      showInfoPopup: false,
      showPopOverSwName: false,
      showTagHistoryPopup: false,
      replaceBadWord: {
        show: false,
        items: [],
        content: ""
      },
      isMenuVisible: false,
      members: [],
      isCanDeleteGroup: false,

      settingGroup: {
        addMemberOnly: 0,
        banDuration: 0,
        bannFeature: 0,
        blockName: 0,
        dirtyMedia: 0,
        enableMsgHistory: 1,
        joinAppr: 0,
        lockCreatePoll: 0,
        lockCreatePost: 0,
        lockSendMsg: 0,
        lockViewMember: 0,
        setTopicOnly: 0,
        signAdminMsg: 1,
        adminIds: []
      },

      filter: {
        isGroup: null,
        unread: false,
        unReplied: null,
        searchKey: "",
        accountIds: [],
        lastMessageTime: 0,
        selectedTags: [],
        dateRange: [],
        pageSize: 30
      },

      selectedConversation: {},
      conversation: {},
      profile: {},
      filterMessage: {
        searchKey: "",
        isGroup: null,
        dateRange: []
      },
      countAll: 0,
      countPersonal: 0,
      countGroup: 0,
      countHidden: 0,
      countPage: 0,

      isChanged: {}
    };
  },
  methods: {
    showTagHistory(item) {
      this.selectCon = item;
      this.showTagHistoryPopup = true;
    },
    showPopOver(item) {
      this.selectCon = item;
      this.showPopOverSwName = true;

    },
    saveSwName() {
      const payload = {
        accountId: this.selectedAccount,
        conversationId: this.selectCon.id,
        swName: this.selectCon.swName
      }
      this.$http.post("/api/conversation/setSwName", payload);
      this.showPopOverSwName = false;
    },
    showInfo(con) {
      if (!con.page && !con.group) {
        this.selectCon = con;
        this.showInfoPopup = true;
      }
    },
    contentNotify(value) {
      if (value) return "Tắt";
      return "Bật";
    },
    contentHidden(value) {
      if (value) return "Hiện";
      return "Ẩn";
    },
    hiddenChange(item) {
      item.hidden = !item.hidden;
      this.$http.get("/api/conversation/hidden", {
        params: {
          accountId: this.selectedAccount,
          conversationId: item.id,
          hidden: item.hidden
        }
      });
    },
    pushNotifyChange(item) {
      item.pushNotify = !item.pushNotify;
      this.$http.get("/api/conversation/pushNotify", {
        params: {
          accountId: this.selectedAccount,
          conversationId: item.id,
          pushNotify: item.pushNotify
        }
      });
    },
    getAvatar(con) {
      if (con.avatar) {
        return con.avatar;
      } else {
        return "/assets/images/no-avatar.png";
      }
    },
    addOrRemoveTag(tag, conversation) {
      let request = {
        conversationId: conversation.id,
        tagId: tag.id
      };
      this.$http.post("/api/conversation/tag", request).then(resp => {
        conversation.tags = resp.data.tags;
        this.$bus.$emit("tagChanged", resp.data);
      });
    },
    checkSelectedTag(tags, id) {
      let filter = tags.filter(p => p.id == id);
      if (filter && filter.length > 0) return true;
      return false;
    },
    closeReplaceBadWord() {
      this.replaceBadWord.show = false;
    },
    handleInputReplace() {
      this.replaceBadWord.items.forEach((it) => {
        for (let item of this.filterCharacterArr()) {

          if (it.replace.toLowerCase() == item.content.toLowerCase()) {
            it.replace = "****";
          }
        }
      });
      this.replaceBadWordContent();
    },
    deleteReplace(item) {
      let filter = this.replaceBadWord.items.filter((con) => con.key == item.key);
      if (filter != null && filter.length > 0) {
        const index = this.replaceBadWord.items.indexOf(filter[0]);
        if (index > -1) {
          this.replaceBadWord.items.splice(index, 1);
          this.replaceBadWordContent();
        }
      }
    },
    filterCharacterArr() {
      const characterArr = this.app.characterFilters;
      const arrCommon = characterArr["0"];
      const arrOnwerAccount = characterArr[this.selectCon.accountId];
      let array = [];
      if (arrCommon && arrCommon.length > 0) {
        array.push(...arrCommon);
      }
      if (arrOnwerAccount && arrOnwerAccount.length > 0) {
        array.push(...arrOnwerAccount);
      }
      const key = "content";
      const unique = [...new Map(array.map(item => [item[key], item])).values()];
      return unique;
    },
    replaceBadWordContent() {
      this.replaceBadWord.content = this.messageText;
      this.replaceBadWord.items.forEach((item) => {
        this.replaceBadWord.content = this.replaceBadWord.content.replaceAll(item.key, item.replace);
      });
    },
    filterCharacter() {
      let items = [];
      let check = true;
      let fil = this.app.accountSetting.filter(p => p.accountId == this.selectCon.accountId);
      if (fil != null && fil.length > 0) {
        check = fil[0].checkBadWord;
      }
      if (check) {
        let text = this.messageText;
        let arr = text.split(" ");
        if (this.filterCharacterArr() && this.filterCharacterArr().length > 0 && arr.length > 0) {
          for (let item of this.filterCharacterArr()) {
            arr.forEach((it) => {
              if (it.toLowerCase() == item.content.toLowerCase()) {
                let fil = items.filter((f) => f.key == it);
                if (fil == null || fil.length == 0) {
                  items.push({ key: it, replace: "****" });
                }
              }
            });
          }
        }
      }
      return items;
    },
    sendMessage() {
      if (!this.messageText) {
        this.alert("error", "Nhập nội dung cần gửi.");
        return;
      }
      let items = this.filterCharacter();
      if (items.length > 0) {
        this.replaceBadWord.show = true;
        this.replaceBadWord.items = items;
        this.replaceBadWordContent();
      } else {
        this.send();
      }
    },
    sendReplace() {
      this.messageText = this.replaceBadWord.content;
      this.closeReplaceBadWord();
      this.send();
    },
    send() {
      let request = {
        accountId: this.selectedAccount,
        toId: this.selectCon.toId,
        groupId: this.selectCon.toId,
        message: this.messageText
      };
      let url = "/api/message/sms";
      if (this.selectCon.group) {
        url = "/api/message/groupMsg";
      }
      this.$http.post(url, request).then(() => {
        this.messageText = "";
        this.showPopupMessage = false;
        this.alert("success", "Đã gửi tin nhắn");
      });
    },
    showPopup(conversation) {
      this.messageText = "";
      this.selectCon = conversation;
      this.showPopupMessage = true;
    },
    getTextBrieflyWithLength(text) {
      return StringUtil.getTextBrieflyWithLength(text, 100);
    },
    checkTag(tagId) {
      let item = this.app.tags.filter(p => p.id == tagId);
      if (item && item.length > 0) return true;
      return false;
    },
    currentSwPageChanged(newPage) {
      this.pageInfo.page = newPage;
      this.getContact();
    },
    searchKeyChanged() {
      this.loading = true;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.getContact(true);
      }, 700);
    },
    getCountConversation() {
      let body = {
        accountId: this.selectedAccount,
        searchKey: this.searchKey,
        selectedTags: this.selectedTag > 0 ? [this.selectedTag] : null,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        type: this.selectType
      };
      this.$http.post("/api/conversationV2/count-by-type", body)
        .then((resp) => {
          this.countAll = resp.data.all;
          this.countPersonal = resp.data.personal;
          this.countGroup = resp.data.group;
          this.countHidden = resp.data.hidden;
          this.countPage = resp.data.page;
        });
    },
    handleGetProfile() {
      const promises = this.itemList
        .filter(item => item.zaloConversation.id === this.conversation.id)
        .map(item => {
          return new Promise((resolve) => {
            setTimeout(() => {
              this.getProfileInfo(item.zaloConversation)
                .then(() => {
                  this.$bus.$on("profileInfo", (payload) => {
                    if (payload.conversationId === item.zaloConversation.id) {
                      if (!item.zaloProfile) {
                        this.$set(item, "zaloProfile", { data: payload.profileInfo });
                      } else {
                        this.$set(item.zaloProfile, "data", { data: payload.profileInfo.data });
                      }
                      this.$bus.$off("profileInfo");
                    }
                  });
                  resolve();
                })
                .catch(error => {
                  console.error(`Failed to get profile info for conversation ID: ${item.zaloConversation.toId}`, error);
                  resolve();
                });
            }, 2000);
          });
        });

      Promise.all(promises)
        .then(() => {
          console.log("Get Profile Success");
        })
        .catch(error => {
          console.error("An error occurred while processing profiles:", error);
        });
    },
    handleGetContact() {
      this.getContact();
    },
    getContact(search = false) {
      if (!this.selectedAccount) return;
      if (search) {
        this.pageInfo.page = 1;
      }
      this.getCountConversation();
      let body = {
        accountId: this.selectedAccount,
        searchKey: this.searchKey,
        selectedTags: this.selectedTag > 0 ? [this.selectedTag] : null,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        type: this.selectType
      };
      this.loading = true;

      this.$http.post("/api/conversationV2/allV2", body)
        .then((rep) => {
          this.pageInfo.total = rep.data.totalElements;
          this.app.contactTotal.all = this.countAll > 0 ? this.countAll : rep.data.totalElements;
          this.itemList = rep.data.content;

          // this.itemList.forEach(item => {
          //   let data;
          //   try {
          //     data = JSON.parse(item.zaloProfile.data);
          //   } catch (e) {
          //     console.error('Invalid JSON in zaloProfile.data:', item.zaloProfile.data);
          //     return;
          //   }
          //
          //   // if (Object.keys(data).length === 0) {
          //   //   this.getProfileInfo(item.zaloConversation);
          //   // }
          // });

        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateProfileInfo(payload) {
      const item = this.itemList.find(i => i.zaloConversation.id === payload.conversationId);
      if (item) {
        item.zaloProfile.data = payload.profileInfo;
        item.zaloProfile.updateAt = Date.now();
      }
    },
    getProfileInfo(conversation) {
      return this.$http.post("/api/messageV2/getProfileInfo", {
        accountId: conversation.accountId,
        toId: conversation.toId,
        group: conversation.group,
        page: conversation.page
      })
        .then((resp) => {
          let profile = {};
          profile = resp?.data?.data ? resp : {};
          return profile;
        })
        .catch(error => {
          console.error(`Failed to get profile info for conversation ID: ${conversation.toId}`, error);
          return {};
        });
    },
    normalizeString(str) {
      const specialCases = {
        "Đ": "D", "đ": "d",
        "Ă": "A", "ă": "a",
        "Â": "A", "â": "a",
        "Ê": "E", "ê": "e",
        "Ô": "O", "ô": "o",
        "Ơ": "O", "ơ": "o",
        "Ư": "U", "ư": "u",
        "Á": "A", "á": "a",
        "À": "A", "à": "a",
        "Ả": "A", "ả": "a",
        "Ã": "A", "ã": "a",
        "Ạ": "A", "ạ": "a",
        "É": "E", "é": "e",
        "È": "E", "è": "e",
        "Ẻ": "E", "ẻ": "e",
        "Ẽ": "E", "ẽ": "e",
        "Ẹ": "E", "ẹ": "e",
        "Í": "I", "í": "i",
        "Ì": "I", "ì": "i",
        "Ỉ": "I", "ỉ": "i",
        "Ĩ": "I", "ĩ": "i",
        "Ị": "I", "ị": "i",
        "Ó": "O", "ó": "o",
        "Ò": "O", "ò": "o",
        "Ỏ": "O", "ỏ": "o",
        "Õ": "O", "õ": "o",
        "Ọ": "O", "ọ": "o",
        "Ú": "U", "ú": "u",
        "Ù": "U", "ù": "u",
        "Ủ": "U", "ủ": "u",
        "Ũ": "U", "ũ": "u",
        "Ụ": "U", "ụ": "u",
        "Ý": "Y", "ý": "y",
        "Ỳ": "Y", "ỳ": "y",
        "Ỷ": "Y", "ỷ": "y",
        "Ỹ": "Y", "ỹ": "y",
        "Ỵ": "Y", "ỵ": "y"
      };
      str = str.replace(/./g, char => specialCases[char] || char);
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
    },
    numberOfType(str) {
      if (str === "all") return this.countAll;
      if (str === "group") return this.countGroup;
      if (str === "personal") return this.countPersonal;
      if (str === "hidden") return this.countHidden;
      if (str === "page") return this.countPage;
    },
    parsedJSON(obj) {
      if (typeof obj === "string") {
        try {
          return JSON.parse(obj);
        } catch (e) {
          console.error("Invalid JSON string:", e);
          return obj;
        }
      }
      return obj;
    },
    getTotalMembers(obj, toId) {
      return this.parsedJSON(obj).data?.gridInfoMap[toId]?.totalMember || "";
    },
    getZaloName(obj, toId) {
      return this.parsedJSON(obj).data?.changed_profiles[toId].zaloName || "";
    },
    showMenuConversationV2(e, item) {
      setTimeout(() => {
        this.isMenuVisible = true;
        if (this.isMenuVisible && item)
          this.$nextTick(() => {
            let tagPin = false;
            this.viewPinConversations.forEach((itemPin) => {
              if (item.zaloConversation.id === itemPin.id) {
                this.conversation = itemPin;
                tagPin = true;
                return;
              }
            });
            if (tagPin !== true)
              this.conversation = { ...item.zaloConversation, isPin: tagPin };
            this.profile = this.getProfileData(item);
            this.setPositionMenuConversationV2(e);
          });
      }, 20);

    },
    setPositionMenuConversationV2(event) {
      const menu = document.getElementById("context-menu-location");
      let topPosition = event.clientY;
      let leftPosition = event.clientX;

      if (window.innerHeight - event.clientY < menu.offsetHeight) {
        topPosition = event.clientY - menu.offsetHeight - 20;
      }

      if (window.innerWidth - event.clientX < menu.offsetWidth) {
        leftPosition = event.clientX - menu.offsetWidth - 20;
      }
      menu.style.top = `${topPosition}px`;
      menu.style.left = `${leftPosition}px`;
    },
    getProfileData(item) {
      try {
        if (!item.zaloConversation.group) {
          return this.parsedJSON(item.zaloProfile.data).data?.changed_profiles[item.zaloConversation.toId] || {};
        } else
          return this.parsedJSON(item.zaloProfile.data).data?.gridInfoMap[item.zaloConversation.toId] || {};
      } catch (e) {
        console.error("error: ", e);
        return {};
      }
    },
    // getSpecificConversation(conversationId) {
    //   const foundItem = this.itemList.find(item => item.zaloConversation.id === conversationId) || null;
    //   this.conversation = foundItem !== null ? foundItem.zaloConversation : null;
    // },
    // getSpecificProfile(conversationId) {
    //   const foundItem = this.itemList.find(item => item.zaloConversation.id === conversationId) || null;
    //   this.profile = foundItem !== null ? this.getProfileData(foundItem) : null;
    // },
    async addMembers(conversation) {
      this.$emit("onSelect", conversation);
      setTimeout(async () => {
        try {
          await this.getGroupInfo(conversation);
          this.$refs.MenuConversationV2.dialogGroup = true;
        } catch (err) {
          console.log("err", err);
        }
      }, 500);
    },
    async addGroup(conversation) {
      this.$emit("onSelect", conversation);
      setTimeout(async () => {
        try {
          await this.getProfileInfo(conversation);
          this.$refs.MenuConversationV2.dialogCreateGroup = true;
        } catch (err) {
          console.log("err", err);
        }
      }, 500);
    },
    async getGroupInfo(conversation) {
      this.isRemove = false;
      const resp = await this.$http.get("/api/message/groupInfoV2", {
        params: {
          accountId: conversation.accountId,
          groupId: conversation.toId
        }
      });
      this.isCanDeleteGroup = false;
      let gridInfoMap = resp.data.data?.gridInfoMap[conversation.toId];
      if (conversation.id == this.conversation.id) {
        if (gridInfoMap) {
          this.settingGroup = gridInfoMap.setting;
          this.settingGroup.adminIds = gridInfoMap.adminIds;
          this.settingGroup.adminIds.push(gridInfoMap.creatorId);

          if (this.conversation.accountId === gridInfoMap.creatorId) {
            this.isCanDeleteGroup = true;
          }
          gridInfoMap.adminIds.forEach((id) => {
            {
              if (this.conversation.accountId === id) this.isCanDeleteGroup = true;
            }
          });
        }
        if (resp.data.data?.removedsGroup.length > 0) {
          this.isRemove = true;
          this.alert("error", "Bạn đã rời khỏi nhóm này");
        }

        // Lấy ds thành viên
        this.members = [];
        gridInfoMap.memberVerMap = {};
        gridInfoMap.memVerList.forEach((i) => {
          let parts = i.split("_");
          gridInfoMap.memberVerMap[parts[0]] = parts[1];
        });
        let memberMap = gridInfoMap.memberVerMap;

        let newMemberMap = {};
        if (!memberMap) return;
        for (const key of Object.keys(memberMap)) {
          let item = this.app.aliases.find((s) => s.id == key && conversation.accountId == s.accountId);
          if (item) {
            this.members.push(item);
          } else {
            newMemberMap[key] = memberMap[key];
          }
        }

        if (Object.keys(newMemberMap).length > 498) {
          const chunkSize = 498;
          for (let i = 0; i < Object.keys(newMemberMap).length; i += chunkSize) {
            let data = Object.fromEntries(Object.entries(newMemberMap).slice(i, i + chunkSize));
            await this.getMembers(data, conversation);
          }
        } else {
          await this.getMembers(newMemberMap, conversation);
        }
      }
    },
    async getMembers(memberMap, conversation) {
      if (Object.keys(memberMap).length === 0) return;
      let request = {
        memberMap: memberMap,
        accountId: conversation.accountId
      };

      const resp = await this.$http.post("/api/conversation/groupMember", request);
      if (conversation.id === this.conversation.id) {
        this.members = [];
        if (resp.data && resp.data.length > 0) {
          this.members.push(...resp.data);
          resp.data.forEach((s) => {
            if (!this.app.aliases.find((a) => a.accountId === this.app.selectedConversation.accountId && s.id === a.id)) {
              this.app.aliases.push(s);
            }
          });
        }
      }
    },
    getTitle() {
      return "Gửi tin nhắn đến " + this.selectCon.toName;
    },
    openChatConversation(e, conversation) {
      if (!this.isMenuVisible && !conversation.hidden) {
        this.$router.push("/conversation").then(() => {
          this.$nextTick(() => {
            this.$bus.$emit("data-from-contact", { conversation });
          });
        });
      }
    },

    getMenuStyle(type) {
      return type.val == this.selectType ? this.activeMenuStyle("#1A6B44") : this.normalMenuStyle("#696B72");
    },
    activeMenuStyle(color) {
      //#0A58C0
      return {
        "border-radius": "4px",
        //   border: "2px solid " + this.setTransparencyHex(color, 0.1),
        "font-weight": "bold",
        color: color,
        "background-color": this.setTransparencyHex(color, 0.1)
      };
    },
    normalMenuStyle(color) {
      //#696B72
      return {
        //   "border-radius": "4px",
        //   border: "2px solid " + this.setTransparencyHex(color, 0.1),
        color: color,
        "font-weight": "500",
        "background-color": "transparent"
      };
    }
  },
  computed: {
    groupedItems() {
      const grouped = {};
      this.itemList.forEach(item => {
        const conversation = item.zaloConversation;
        if (!conversation.group) {
          const rawName =
            conversation.toName ||
            conversation.swName ||
            '';

          const firstLetter = this.normalizeString(rawName)[0];
          let groupedKey;
          if (/^[A-Z]$/.test(firstLetter)) {
            groupedKey = firstLetter;
          } else if (/^\d$/.test(firstLetter)) {
            groupedKey = "123";
          } else {
            groupedKey = "*";
          }
          if (!grouped[groupedKey]) {
            grouped[groupedKey] = [];
          }
          grouped[groupedKey].push(item);
        }
      });
      return grouped;
    },
    sortedGroups() {
      return Object.keys(this.groupedItems).sort();
    },

    viewPinConversations() {
      let view = [...this.app.pinConversationView].filter((c) => !c.hidden);
      if (this.filter.isGroup !== null) {
        view = view.filter((p) => p.group == this.filter.isGroup);
      }
      if (this.filter.unread) {
        view = view.filter((p) => p.unreadCount > 0);
      }
      if (this.filter.unReplied) {
        view = view.filter((p) => p.unReplied);
      }
      if (this.filter.searchKey !== "") {
        view = view.filter(
          (p) =>
            p.toName.toLowerCase().includes(this.filter.searchKey.toLowerCase()) ||
            (p.phone && p.phone.includes(this.subPhone(this.filter.searchKey))) ||
            (p.swName && p.swName.toLowerCase().includes(this.filter.searchKey.toLowerCase()))
        );
      }
      if (this.filter.accountIds.length > 0) {
        view = view.filter((p) => this.checkAcc(p.accountId) == true);
      }
      if (this.filter.selectedTags.length > 0) {
        view = view.filter((p) => this.checkTags(p.tags) == true);
      }
      view.sort((a, b) => b.lastMessageTime - a.lastMessageTime);
      return view;
    }
  },

  mounted() {
    this.$bus.$on("closeProfile", () => this.showInfoPopup = false);
    window.addEventListener("click", () => {
      this.isMenuVisible = false;
    });
    this.$bus.$on("profileInfo", this.updateProfileInfo);
  },
  beforeDestroy() {
    this.$bus.$off("closeProfile");
    this.$bus.$off("profileInfo");
  },
  created() {
    if (this.selectedAccount) {
      this.getContact();
    }
  }
};
</script>

<style scoped>
.contact-item:hover {
  background-color: #F5F9FE;
  cursor: pointer;
}

</style>
